/**
 * PhoneModal — replaces $scope.phoneModal (templates/phone_modal.html).
 * Shows pending customers marked for phone call (phone_night_before=true).
 */

import { Box, Button, Group, Text } from '@mantine/core';
import { IconPhone } from '@tabler/icons-react';
import { ModalFrame } from './ModalFrame';
import type { RunsheetLine } from '@/types';

function formatPhone(raw: string): string {
  let d = raw.replace(/\D/g, '');
  if (d.length === 9 && d.startsWith('0')) d = d.slice(1);
  if (d.length === 8) return `${d.slice(0, 4)} ${d.slice(4)}`;
  if (d.length === 10 && (d.startsWith('04') || d.startsWith('05')))
    return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7)}`;
  if (d.length === 10) return `${d.slice(0, 2)} ${d.slice(2, 6)} ${d.slice(6)}`;
  return raw;
}

function phoneNumbers(item: RunsheetLine): { label: string; number: string }[] {
  return [
    { label: 'Mob', number: item.ph_mob },
    { label: 'Home', number: item.ph_home },
    { label: 'Work', number: item.ph_work },
  ].filter(({ number }) => number);
}

interface Props {
  opened: boolean;
  phonelist: RunsheetLine[];
  onClose: () => void;
}

export function PhoneModal({ opened, phonelist, onClose }: Props) {
  return (
    <ModalFrame opened={opened} onClose={onClose} title="Phone Clients">
      {phonelist.map(item => (
        <Box
          key={item.customerid}
          py="xs"
          style={{ borderBottom: '1px solid var(--mantine-color-gray-2)' }}
        >
          <Text fw={600}>{item.namewithid}</Text>
          <Text fz="sm" c="dimmed">
            {item.deliveryaddress}
          </Text>
          <Group gap="xs" mt={6}>
            {phoneNumbers(item).map(({ label, number }) => (
              <Button
                key={label}
                component="a"
                href={`tel:${number}`}
                variant="light"
                color="teal"
                leftSection={<IconPhone size={20} />}
              >
                {label} {formatPhone(number)}
              </Button>
            ))}
          </Group>
        </Box>
      ))}
    </ModalFrame>
  );
}
